interface IconTooltipProps {
	id: string;
	showTooltip: boolean;
	pageY: number;
	pageX: number;
	tooltipText: string;
}
function IconTooltip({ id, showTooltip, pageX, pageY, tooltipText }: IconTooltipProps): JSX.Element {
	return (
		<div id={`tooltip-${id}`} style={{
			visibility: showTooltip ? 'visible' : 'hidden',
			position: 'absolute',
			zIndex: 10,
			padding: '10px',
			background: 'rgba(0,0,0,1)',
			borderRadius: '4px',
			color: '#fff',
			top: `${pageY - 10}px`,
			left: `${pageX + 10}px`,
			fontSize: "10px",
			width: "300px"
		}}>
			{tooltipText}
		</div>
	);
}


export default IconTooltip;
